var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgTableIcon = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.5 4.0625H2.5C2.41712 4.0625 2.33763 4.09542 2.27903 4.15403C2.22042 4.21263 2.1875 4.29212 2.1875 4.375V15C2.1875 15.2486 2.28627 15.4871 2.46209 15.6629C2.6379 15.8387 2.87636 15.9375 3.125 15.9375H16.875C17.1236 15.9375 17.3621 15.8387 17.5379 15.6629C17.7137 15.4871 17.8125 15.2486 17.8125 15V4.375C17.8125 4.29212 17.7796 4.21263 17.721 4.15403C17.6624 4.09542 17.5829 4.0625 17.5 4.0625ZM2.8125 8.4375H6.5625V11.5625H2.8125V8.4375ZM7.1875 8.4375H17.1875V11.5625H7.1875V8.4375ZM17.1875 4.6875V7.8125H2.8125V4.6875H17.1875ZM2.8125 15V12.1875H6.5625V15.3125H3.125C3.04212 15.3125 2.96263 15.2796 2.90403 15.221C2.84542 15.1624 2.8125 15.0829 2.8125 15ZM16.875 15.3125H7.1875V12.1875H17.1875V15C17.1875 15.0829 17.1546 15.1624 17.096 15.221C17.0374 15.2796 16.9579 15.3125 16.875 15.3125Z",
    fill: "#4D5F6E"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgTableIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/tableIcon.e6f3fdc6932fdf0d485b3005e4b79175.svg";